var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-partition',{attrs:{"title":"账单信息"}},[_c('Table',{ref:"mt",attrs:{"columns":_vm.columns,"data":_vm.list,"height":"350","loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }